import {RestService} from "@/services/rest/RestService";
import {WidgetSelectionApi} from "@/api/care-calendar-widget-selection";
import {CodeDescriptionRestDto, SelectableWidgetResultsRestDto} from "@/api/care-calendar-widget-selection/models";
import {AxiosResponse} from "axios";

export class WidgetSelectionRestService extends RestService {
    private apiService: WidgetSelectionApi;

    protected constructor() {
        super();
        this.apiService = new WidgetSelectionApi(this.getDpAxiosV2Instance(), undefined, this.getApiGwUrl('/care-calendar'));
    }

    public async findSelectableBookingWidgets(): Promise<CodeDescriptionRestDto[]> {
        const response: AxiosResponse<SelectableWidgetResultsRestDto> =
            await this.apiService.findSelectableBookingWidgets(this.getCustomerCode());

        return response.data.results;
    }
}
